export default __webpack_public_path__ + "static/media/icons8-trash-96 1.10eab939.svg";